import enUS from "../../lang/en.json";
import { IntlMessageID } from "../enum";

export const lang = (messageId: IntlMessageID) => {
  return enUS[messageId];
};
